/**
 * Created by Ivan on 10.08.2026
 */

const StickersPackView2 = function (packSpine, stickersAmount) {
    return Prefab.instantiate(bundles.stickers2_reward_window.jsons.stickers_pack_prefab_json, { stickersAmount });
};
